import { render, staticRenderFns } from "./TbSatuanTertutup.vue?vue&type=template&id=aabe25f0"
import script from "./TbSatuanTertutup.vue?vue&type=script&lang=js"
export * from "./TbSatuanTertutup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports